var _path, _path2, _path3, _path4, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircles(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 376 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.119 359.67C144.482 359.67 101.659 341.878 69.3912 309.61C37.1235 277.342 19.3309 234.52 19.3309 188.882C19.3309 143.245 37.1235 100.422 69.3912 68.1545C101.659 35.8867 144.482 18.0942 190.119 18.0942C235.756 18.0942 278.579 35.8867 310.847 68.1545C343.114 100.422 360.907 143.245 360.907 188.882C360.907 234.52 343.114 277.342 310.847 309.61C278.579 341.878 235.756 359.67 190.119 359.67ZM190.119 21.311C97.7386 21.311 22.5477 96.5019 22.5477 188.882C22.5477 281.263 97.7386 356.554 190.219 356.554C282.6 356.554 357.891 281.363 357.891 188.882C357.791 96.5019 282.6 21.311 190.119 21.311Z",
    fill: "url(#circles_wrapper_paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.537 344.793C147.497 344.793 104.172 326.9 71.6027 294.33C39.0334 261.761 21.1403 218.436 21.1403 172.396C21.1403 126.357 39.0334 83.0317 71.6027 50.4624C104.172 17.893 147.497 0 193.537 0C239.576 0 282.901 17.893 315.471 50.4624C348.04 83.0317 365.933 126.357 365.933 172.396C365.933 218.436 348.04 261.761 315.471 294.33C282.901 326.9 239.576 344.793 193.537 344.793ZM193.537 1.30679C99.1459 1.30679 22.4471 78.1061 22.4471 172.396C22.4471 266.687 99.2464 343.486 193.537 343.486C287.927 343.486 364.626 266.687 364.626 172.396C364.626 78.1061 287.927 1.30679 193.537 1.30679Z",
    fill: "url(#circles_wrapper_paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.332 375.151C127.293 375.151 83.9673 357.258 51.3979 324.688C18.8286 292.119 0.935547 248.794 0.935547 202.754C0.935547 156.715 18.8286 113.39 51.3979 80.8202C83.9673 48.2509 127.293 30.3578 173.332 30.3578C219.371 30.3578 262.697 48.2509 295.266 80.8202C327.835 113.39 345.728 156.715 345.728 202.754C345.728 248.794 327.835 292.119 295.266 324.688C262.697 357.157 219.371 375.151 173.332 375.151ZM173.332 31.5641C78.9411 31.5641 2.24234 108.363 2.24234 202.654C2.24234 297.044 79.0417 373.743 173.332 373.743C267.622 373.743 344.422 296.944 344.422 202.654C344.422 108.363 267.723 31.5641 173.332 31.5641Z",
    fill: "url(#circles_wrapper_paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.489 362.384C157.449 362.384 114.124 344.491 81.5547 311.922C48.9853 279.353 31.0923 236.027 31.0923 189.988C31.0923 143.949 48.9853 100.623 81.5547 68.0539C114.124 35.4846 157.449 17.5916 203.489 17.5916C249.528 17.5916 292.853 35.4846 325.423 68.0539C357.992 100.623 375.885 143.949 375.885 189.988C375.885 236.027 357.992 279.353 325.423 311.922C292.853 344.491 249.528 362.384 203.489 362.384ZM203.489 18.8983C109.098 18.8983 32.3991 95.6977 32.3991 189.988C32.3991 284.379 109.198 361.078 203.489 361.078C297.879 361.078 374.578 284.278 374.578 189.988C374.578 95.5971 297.879 18.8983 203.489 18.8983Z",
    fill: "url(#circles_wrapper_paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "circles_wrapper_paint0_linear",
    x1: 31.116,
    y1: 190.004,
    x2: 375.883,
    y2: 190.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circles_wrapper_paint1_linear",
    x1: 31.116,
    y1: 190.004,
    x2: 375.883,
    y2: 190.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circles_wrapper_paint2_linear",
    x1: 31.116,
    y1: 190.004,
    x2: 375.883,
    y2: 190.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circles_wrapper_paint3_linear",
    x1: 31.116,
    y1: 190.004,
    x2: 375.883,
    y2: 190.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.be3bb5c1.svg";
export { ForwardRef as ReactComponent };